(() => {
  document.querySelectorAll('[data-anya-product]').forEach((product) => {
    const slides = [...product.querySelectorAll('[data-product-slide]')];
    const thumbs = [...product.querySelectorAll('[data-gallery-thumb]')];
    const counter = product.querySelector('[data-gallery-counter]');
    const selectors = [...product.querySelectorAll('[data-product-option]')];
    const variantInput = product.querySelector('[data-variant-id]');
    const quantityInput = product.querySelector('[data-product-quantity]');
    const price = product.querySelector('[data-product-price]');
    const whatsapp = product.querySelector('[data-product-whatsapp]');
    const status = product.querySelector('[data-product-status]');
    const variantsNode = product.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const currency = product.dataset.currency || 'DH';
    const shipping = Number(product.dataset.shippingPrice || 0);
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let selectedVariant = variants.find((variant) => String(variant.id) === variantInput?.value) || variants[0];

    const money = (cents) => `${Number(cents / 100).toLocaleString('fr-FR')} ${currency}`;
    const showSlide = (index) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === activeIndex);
        slide.setAttribute('aria-hidden', String(i !== activeIndex));
      });
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === activeIndex));
      if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
      thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showSlide(i)));
    product.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
    product.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));

    const updateVariant = () => {
      const options = selectors.map((selector) => selector.value);
      selectedVariant = variants.find((variant) => variant.options.length === options.length && variant.options.every((option, i) => option === options[i]));
      if (!selectedVariant) {
        status.textContent = 'Cette combinaison n’est pas disponible.';
        whatsapp.disabled = true;
        return;
      }
      status.textContent = '';
      whatsapp.disabled = false;
      variantInput.value = selectedVariant.id;
      price.textContent = money(selectedVariant.price);
      if (selectedVariant.featured_media) {
        const mediaIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(selectedVariant.featured_media.id));
        if (mediaIndex >= 0) showSlide(mediaIndex);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selectedVariant.id);
      window.history.replaceState({}, '', url);
    };

    selectors.forEach((selector) => selector.addEventListener('change', updateVariant));
    whatsapp?.addEventListener('click', () => {
      const phone = (product.dataset.whatsappNumber || '').replace(/\D/g, '');
      if (!phone || !selectedVariant) {
        status.textContent = 'La commande WhatsApp n’est pas disponible pour le moment.';
        return;
      }
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const productTotal = (selectedVariant.price / 100) * quantity;
      const options = selectors.map((selector) => `${selector.previousElementSibling.textContent} : ${selector.value}`);
      const title = product.querySelector('h1')?.textContent.trim() || 'Déodorant crème naturel ANYA.';
      const message = ['Bonjour ANYA.','','Je souhaite commander :',`Produit : ${title}`,...options,`Quantité : ${quantity}`,'',`Prix produits : ${productTotal.toLocaleString('fr-FR')} ${currency}`,`Livraison : ${shipping.toLocaleString('fr-FR')} ${currency}`,`Total estimé : ${(productTotal + shipping).toLocaleString('fr-FR')} ${currency}`,'','Merci de confirmer la disponibilité et ma commande.'].join('\n');
      status.textContent = '';
      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
    });

    showSlide(activeIndex);
    updateVariant();
  });
})();
